import type WordBreakStyles from './types';

const wordBreak: WordBreakStyles = {
    breakWord: {
        wordBreak: 'break-word',
    },
    breakAll: {
        wordBreak: 'break-all',
    },
};

export default wordBreak;
